import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "StyledKModalImportHeader";
var classes = {
    textButton: "".concat(PREFIX, "-textButton"),
    outlinedButton: "".concat(PREFIX, "-outlinedButton")
};
var StyledKModalImportHeader = styled(Box)(function (_a) {
    var _b, _c;
    var theme = _a.theme;
    return (_b = {
            display: "flex",
            justifyContent: "flex-end"
        },
        _b[theme.breakpoints.down("md")] = {
            width: "45vw"
        },
        _b["& .".concat(classes.textButton)] = {
            color: theme.palette.grey[300],
            fontWeight: "bold",
            textTransform: "uppercase",
            margin: theme.spacing(2),
            fontSize: ".7rem",
            flexShrink: 0
        },
        _b["& .".concat(classes.outlinedButton)] = (_c = {
                color: theme.palette.common.black,
                backgroundColor: theme.palette.grey[300],
                fontWeight: "bold",
                textTransform: "uppercase",
                margin: theme.spacing(2),
                padding: theme.spacing(0.5, 1),
                fontSize: ".7rem",
                border: "none",
                ":hover": {
                    backgroundColor: theme.palette.grey[300]
                }
            },
            _c[theme.breakpoints.down("sm")] = {
                fontSize: ".5rem",
                span: {
                    display: "none"
                }
            },
            _c),
        _b);
});

export { classes, StyledKModalImportHeader as default };
//# sourceMappingURL=index.styled.js.map
